<template>
  <div class="revenue">
    <div class="revenue-wrap">
      <div class="block">
        <div class="item" v-for="s in sales" :key="s.title">
          <img class="item-icon" :src="s.icon" />
          <div class="item-main">
            <div class="main-header">{{ s.title }}</div>
            <div class="main-money">￥{{ dealData[s.key] }}</div>
          </div>
        </div>
        <div class="tip">统计截止日期：{{ dealData.billDate }}</div>
      </div>
      <div class="block">
        <div class="item" v-for="s in settle" :key="s.title">
          <img class="item-icon" :src="s.icon" />
          <div class="item-main">
            <div class="main-header">{{ s.title }}</div>
            <div class="main-money">￥{{ settleData[s.key] }}</div>
          </div>
        </div>
        <div class="tip">统计截止日期：{{ settleData.date }}</div>
      </div>
    </div>
    <div class="revenue-wrap">
      <div class="chart-wrap">
        <div class="title">
          交易统计
          <el-select size="mini" class="select-during" v-model="dealSelect" @change="changeDealchart" style="width:100%">
            <el-option v-for="l in selections" :key="l.label" :value="l.value" :label="l.label"></el-option>
          </el-select>
        </div>
        <div id="dealchartId"></div>
      </div>
      <div class="chart-wrap">
        <div class="title">
          结算统计
          <el-select size="mini" class="select-during" v-model="settleSelect" @change="changeSettlechart" style="width:100%">
            <el-option v-for="l in selections" :key="l.label" :value="l.value" :label="l.label"></el-option>
          </el-select>
        </div>
        <div id="settleChartId"></div>
      </div>
    </div>
  </div>
</template>
<script  >

import * as echarts from 'echarts/core';
import {
  TooltipComponent,
  GridComponent,
  LegendComponent
} from 'echarts/components';
import { BarChart } from 'echarts/charts';
import { CanvasRenderer } from 'echarts/renderers';
import BillService from '@/apis/BillService';

echarts.use([
  TooltipComponent,
  GridComponent,
  LegendComponent,
  BarChart,
  CanvasRenderer
]);


export default {
  data() {
    return {
      dealData: {},
      settleData: {},
      sales: [
        {
          icon: require(`../../assets/img/revenue/revenue-total.png`),
          title: "累计销售总额",
          key: "merchantTotal",
        },
        {
          icon: require(`../../assets/img/revenue/revenue-charge.png`),
          title: "服务费总额",
          key: "serviceCharge",
        },
      ],
      settle: [
        {
          icon: require(`../../assets/img/revenue/settle-total.png`),
          title: "累计结算金额",
          key: "merchantMoney",
        },
        {
          icon: require(`../../assets/img/revenue/settle-unpay.png`),
          title: "待结算金额",
          key: "merchanWaitForMoney",
        },
      ],
      selections: [
        {
          label: "近7天",
          value: 1
        },
        {
          label: "近30天",
          value: 2
        },
        {
          label: "近12个月",
          value: 3
        },
      ],
      dealSelect: 1,
      settleSelect: 1
    }
  },
  mounted() {
    this.initChart();
    this.getlData();
  },
  methods: {
    initChart() {
      this.dealChart = echarts.init(document.getElementById("dealchartId"))
      this.settleChart = echarts.init(document.getElementById("settleChartId"))
      window.onresize = () => {
        this.dealChart.resize();
        this.settleChart.resize();
      };
    },
    // 获取交易的数据
    getlData() {
      BillService.getBillStatisticalTotal().then(res => {
        this.dealData = res;
      });
      BillService.getSettlementAmount().then(res => {
        this.settleData = res;
      });
      this.getDealChartData();
      this.getSettleChartData();
    },
    // 获取交易的数据
    getDealChartData() {
      BillService.getBillStatisticalRecent(this.dealSelect).then(res => {
        this.initDealChart(res);
      })
    },
    // 获取结算的数据
    getSettleChartData() {
      BillService.getSettlementHistogram(this.settleSelect).then(res => {
        this.initSettleChart(res);
      })
    },
    initDealChart(list) {
      this.dealChart.setOption({
        xAxis: {
          data: list.map(i => i.no)
        },
        legend: {
          left: 18,
          data: ['退款金额', '交易金额']
        },
        yAxis: {},
        tooltip: {
          trigger: "axis",
          axisPointer: { type: "none" },
          formatter: '{b} <br/> {a}：{c} <br/> {a1}：{c1} '
        },
        grid: { left: 70, right: 20, bottom: 50 },
        series: [
          {
            name: '退款金额',
            type: 'bar',
            barMaxWidth: "25px",
            barGap: "-50%",
            color: "#CFDFEE",
            itemStyle: { borderRadius: [5, 5, 0, 0] },
            data: list.map(i => i.refundMoney)
          },
          {
            name: '交易金额',
            type: 'bar',
            barGap: "-50%",
            barMaxWidth: "25px",
            color: "#376895",
            itemStyle: { borderRadius: [5, 5, 0, 0] },
            data: list.map(i => i.payMoney)
          }
        ]
      });
    },
    initSettleChart(list) {
      this.settleChart.setOption({
        tooltip: {},
        xAxis: {
          data: list.map(i => i.date)
        },
        yAxis: {},
        grid: { left: 70, right: 20, bottom: 50 },
        series: [
          {
            name: '',
            type: 'bar',
            color: "#376895",
            barWidth: "25px",
            itemStyle: { borderRadius: [5, 5, 0, 0] },
            data: list.map(i => i.amount)
          }
        ]
      });
    },
    changeDealchart() {
      this.getDealChartData();
    },
    changeSettlechart(param) {
      this.getSettleChartData();
    }
  }
};
</script>
<style lang="scss">
.revenue {
  background-color: transparent !important;
  padding: 0 !important;
}
.revenue-wrap {
  display: flex;
  position: relative;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.block {
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  margin-right: 20px;
  padding: 50px 26px 30px;
  box-sizing: border-box;
  background-color: #fff;
  border-radius: 8px;
  position: relative;
  &:nth-child(2n) {
    margin-right: 0;
  }
  .tip {
    position: absolute;
    left: 26px;
    top: 15px;
    font-size: 12px;
    color: #a0a2b7;
  }
  .item {
    display: flex;
    width: 50%;
    box-sizing: border-box;
    &:nth-child(1) {
      border-right: 2px solid #ececec;
      padding-right: 30px;
    }
    &:nth-child(2) {
      padding-left: 30px;
    }
  }
  .item-icon {
    width: 64px;
    height: 64px;
  }
  .item-main {
    padding-left: 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
  }
  .main-header {
    font-size: 14px;
    color: #737588;
  }
  .main-money {
    font-size: 20px;
    color: #333333;
  }
}
.chart-wrap {
  flex: 1;
  margin-right: 20px;
  background-color: #fff;
  border-radius: 8px;
  &:nth-child(2n) {
    margin-right: 0;
  }
  .title {
    display: flex;
    font-size: 16px;
    line-height: 28px;
    padding: 15px 20px 10px;
    justify-content: space-between;
    border-bottom: 1px solid #eaeaea;
  }
  .select-during {
    width: 100px !important;
  }
}
#dealchartId,
#settleChartId {
  width: 100%;
  padding-top: 20px;
  height: 450px;
}
</style>